<template>
    <tooltip-icon
            :color="color"
            v-bind="$attrs"
            v-on="$listeners"
            :tooltip="tooltip"
    >
        mdi-pencil
    </tooltip-icon>
</template>

<script>
    import TooltipIcon from './TooltipIcon'

    const
        defaultColor = 'amber darken-3',
        defaultTooltip = 'pages.all.actions.edit'

    export default {
        name: "EditIcon",
        inheritAttrs: false,
        components: {
            TooltipIcon
        },
        props: {
            color: {
                required: false,
                type: String,
                default: defaultColor,
            },
            tooltip: {
                required: false,
                default: defaultTooltip,
            },
        },
    }
</script>
